
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function FinalCTA() {
  const { ref, isVisible } = useScrollReveal(0.2);

  return (
    <section id="consultation" className="relative py-40 md:py-48 overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/a8a9ea6c19fc76f28481ba4e22f0d7e7.jpg"
          alt="Strategic AI consultation"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0D10] via-[#0B0D10]/85 to-[#0B0D10]"></div>

      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <p className="text-sm tracking-[0.25em] uppercase text-[#3A5F8C] mb-6 font-medium">Get Started</p>
        <h2 className="text-4xl md:text-5xl lg:text-[56px] font-bold text-[#F5F7FA] tracking-tight leading-[1.1] mb-8">
          Ready for Strategic<br />AI Clarity?
        </h2>

        <p className="text-lg text-[#F5F7FA]/60 mb-14 leading-relaxed max-w-2xl mx-auto">
          Request an AI audit and identify where intelligent automation delivers real business value.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <a
            href="#contact"
            className="px-10 py-4 bg-[#F5F7FA] text-[#0B0D10] text-sm font-semibold rounded-full hover:bg-white transition-all cursor-pointer whitespace-nowrap shadow-2xl hover:shadow-white/10 hover:scale-105 duration-300"
          >
            Schedule an Executive Consultation
          </a>
          <a
            href="#framework"
            className="px-10 py-4 bg-[#F5F7FA]/10 backdrop-blur-sm text-[#F5F7FA] text-sm font-medium rounded-full hover:bg-[#F5F7FA]/20 transition-all cursor-pointer whitespace-nowrap border border-[#F5F7FA]/20 duration-300"
          >
            Download AI Readiness Framework
          </a>
        </div>
      </div>
    </section>
  );
}
